import Logger from '../../functions/logging';

import { 
	STORE_GLOBAL_ANALYTICS_ADAPTER, 
	STORE_GA_TRACKER, 
	//STORE_MP_TRACKER 
} from '../actions/constants';

const GlobalAnalyticsAdapterReducer = (state = {}, action) => {
	Logger.log('TRACKER 2', action.gaTracker);
	switch (action.type) {
		
		case STORE_GLOBAL_ANALYTICS_ADAPTER:
			return { ...state, globalAnalyticsAdapter: action.globalAnalyticsAdapter };
		case STORE_GA_TRACKER:
			return { ...state, gaTracker: action.gaTracker };
		// case STORE_MP_TRACKER:
		// 	return { ...state, mpTracker: action.mpTracker };
	}
	return state;
};

export default GlobalAnalyticsAdapterReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/GlobalAnalyticsAdapterReducer.js